<template>
    <div class="delivery-main-page">
        <div class="mb-3 border-bottom">
            <div class="d-flex mb-2">
                <h1 class="pr-3 h2 mb-0">Commandes à livrer</h1>
                <div class="px-2">
                    <DeliveryRoundsDatepicker
                        class="datepicker"
                        :value="deliveryDate"
                    />
                </div>
                <div class="pr-2 pl-1">
                    <div
                        v-if="deliveryDate == todayDate"
                        class="text-success mt-2"
                    >
                        <i class="fas fa-check"></i> Aujourd'hui
                    </div>
                    <button
                        v-if="deliveryDate != todayDate"
                        class="btn btn-warning"
                        @click="selectToday"
                    >
                        <i class="fas fa-eye"></i> Aujourd'hui
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import DeliveryRoundsDatepicker from "./DeliveryRoundsDatepicker"
    import {momentDay} from "../../moment-with-helpers";

    export default {
        name: 'DeliveryMainPage',

        components: {
            DeliveryRoundsDatepicker,
        },

        props: {
            deliveryDate: {
                type: String,
                required: true,
            },
        },

        computed: {
            formattedDeliveryDate() {
                return momentDay(this.deliveryDate).format('dddd Do MMMM YYYY');
            },

            todayDate() {
                return momentDay().format('YYYY-MM-DD')
            },
        },

        methods: {
            selectToday() {
                return this.onSelectDate(momentDay().toDate());
            },

            onSelectDate(e) {
                if (e instanceof Date) {
                    var date = moment(e).format('YYYY-MM-DD')
                    window.location = '/espace-employes/commandes/livraison/' + date;
                }
            },
        },
    }
</script>
